export const BuildInfo = {timestamp:1787788645000}
